import { Dispatch, SetStateAction } from 'react'
import classNames from 'classnames'
import { SelectOption } from '../../interfaces/SelectOption'
import './ToolbarDownloadSelect.scss'

interface Props<T> {
  value: T
  setValue: Dispatch<SetStateAction<T>>
  options: SelectOption<T>[]
}

export function ToolbarDownloadSelect<T>({ value, setValue, options }: Props<T>) {
  return (
    <div className="ToolbarDownloadSelect">
      {options.map((option, index) => (
        <button
          className={classNames('option', {
            '-selected': value === option.value,
          })}
          onClick={() => setValue(option.value)}
          disabled={option.disabled}
          key={index}
        >
          {option.title || <>{option.value}</>}
        </button>
      ))}
    </div>
  )
}
